import { observer } from "mobx-react-lite";

import { useSchemaEditor } from "../..";
import { ISchemaParameter } from "../schema-parameter-store";

import { Input } from "@/components/ui/input";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface Props {
  parameter: ISchemaParameter;
}

const ArrayParameterContent = observer(({ parameter }: Props) => {
  const editor = useSchemaEditor();
  const { isReadonly } = editor;

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="array-constraints" className="ml-8 text-xs">
        <AccordionTrigger className="font-normal text-gray-700">Array Constraints</AccordionTrigger>
        <AccordionContent>
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-4 gap-4 sm:grid-cols-2 md:grid-cols-3">
              <div className="flex flex-col gap-1">
                <label className="text-xs text-gray-500">Minimum Items</label>
                <Input
                  value={parameter.minItems || ""}
                  onChange={e => parameter.setMinItems(e.target.value)}
                  readOnly={isReadonly}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs text-gray-500">Maximum Items</label>
                <Input
                  value={parameter.maxItems || ""}
                  onChange={e => parameter.setMaxItems(e.target.value)}
                  readOnly={isReadonly}
                />
              </div>
            </div>
            {/* TODO: Add prefix items. */}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
});

export { ArrayParameterContent };
